import React from 'react';

import { useAppConfigStateContext } from '@edx/contexts/app-config';
import { IconAngleRight } from '@edx/components/icons';
import { Link } from '@edx/components/link';
import { Body, Title } from '@edx/components/typography';

export const HowItWorks: React.FC = () => {
  const { projectShortName } = useAppConfigStateContext();

  return (
    <section className="relative overflow-hidden border-b border-white border-opacity-10">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-full sm:col-span-7 flex items-center md:col-span-6 lg:col-span-5 lg:px-0 py-24">
            <div className="font-body text-base text-gray-500">
              <div className="border-2 border-primary-500 w-8" />

              <div className="mt-4">
                <Title tag="h3" className="text-gray-300">
                  ¿Cómo funciona?
                </Title>

                <div className="mt-8 mb-4 space-y-4">
                  <Body>
                    {projectShortName} es una escuela online que funciona por suscripción. Contamos con el método de
                    enseñanza más eficaz para que mejores desde el primer día. Es un método moderno y cercano, te
                    enseñamos el camino más fácil y ameno para aprender sin rodeos y con ejemplos claros sin que dejar
                    lugar a dudas y para que puedas ponerlos en práctica fácilmente.
                  </Body>
                  <Body>
                    A día de hoy contamos con más de 250 vídeos repartidos en diferentes secciones: cursos, ejercicios,
                    repertorio, consejos, y Q&A.
                  </Body>
                </div>

                <Link
                  href="/como-funciona"
                  className="flex items-center text-white text-sm md:text-base uppercase tracking-widest group transform hover:-translate-x-0.5 transition duration-150 ease-in-out"
                >
                  Leer más{' '}
                  <IconAngleRight className="w-4 ms:w-5 h-4 md:h-5 transform group-hover:translate-x-1 group-hover:text-primary-500 transition-all duration-150 ease-in-out" />
                </Link>
              </div>
            </div>
          </div>

          <div className="col-span-6">
            <picture className="hidden sm:block absolute inset-y-0 min-w-full">
              <source media="(min-width: 1122px)" srcSet="/img/miki-santamaria/image-section-2.jpg" />
              <source media="(min-width: 641px)" srcSet="/img/miki-santamaria/image-section-2.jpg" />
              <img src="/img/miki-santamaria/image-section-2.jpg" alt="" width="820" />
            </picture>
          </div>
        </div>
      </div>
    </section>
  );
};
